<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="active">Active:</label>
        <div>
          <model-select
            :options="activeOptions"
            v-model="editIsActive"
            placeholder="Active"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="verified">Verified:</label>
        <div>
          <model-select
            :options="verifiedOptions"
            v-model="editVerified"
            placeholder="Verified"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="Vaccination">Vaccination:</label>
        <div>
          <model-select
            :options="verifiedOptions"
            v-model="editVaccination"
            placeholder="Vaccination"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="email">Email:</label>
        <div>
          <input type="text" placeholder="Email" v-model="editEmail" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Phone Number:</label>
        <div>
          <input
            type="text"
            placeholder="Phone Number"
            v-model="editPhoneNumber"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Title:</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="metro">Metro:</label>
        <div>
          <model-select
            :options="metroOptions"
            v-model="editMetro"
            placeholder="Metro"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Address:</label>
        <div>
          <input type="text" placeholder="Address" v-model="editAddress" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Stripe Id:</label>
        <div>
          <input type="text" placeholder="Stripe Id" v-model="editStripeId" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate:</label>
        <div>
          <input type="text" placeholder="Rate" v-model="editRate" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="rateType">Rate Type:</label>
        <div>
          <model-select
            :options="rateTypeOptions"
            v-model="editRateType"
            placeholder="RateType"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Work Type:</label>
        <div>
          <multi-select
            :options="workTypeOptions"
            :selected-options="editWorkType"
            @select="onSelectWorkType"
            placeholder="WorkType"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Statuses:</label>
        <div>
          <multi-select
            :options="techStatusOptions"
            :selected-options="editTechStatus"
            @select="onSelectTechStatus"
            placeholder="Statuses"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Application Status:</label>
        <div>
          <model-select
            :options="applicationStatusOptions"
            v-model="editApplicationStatus"
            placeholder="Application Status"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Tech Level:</label>
        <div>
          <model-select
            :options="techLevelOptions"
            v-model="editTechLevel"
            placeholder="Tech Level"
          ></model-select>
        </div>
      </div>
      <!-- <div class="form-inline">
        <label>Video:</label>
        <div>
          <input type="text" placeholder="Video" v-model="editVideo" />
        </div>
      </div> -->
      <div class="form-inline flex-row">
        <label>Bio:</label>
        <div>
          <textarea rows="3" placeholder="Bio" v-model="editBio" />
        </div>
      </div>
      <div class="form-inline" v-if="editType == 'add'">
        <label for="password">Password:</label>
        <div>
          <input
            name="password"
            id="password"
            type="text"
            placeholder="Password"
            v-model="editPassword"
          />
        </div>
      </div>
      <div class="form-inline flex-row" v-if="editType == 'add'">
        <label for="sendEmail">Send Email:</label>
        <div>
          <model-select
            :options="sendEmailOptions"
            v-model="editSendEmail"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { MultiSelect, ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { db } from "@/vendor/firebase";
import * as constant from "@/constant/constant";
import spinnerButton from "@/components/public/SpinnerButton";
import * as utils from "@/utils/utils";

export default {
  props: ["propsData", "submitLoading"],
  components: {
    ModelSelect,
    MultiSelect,
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      metroOptions: [],
      applicationStatusOptions: [],
      techLevelOptions: [],
      workTypeOptions: [],
      techStatusOptions: [],
      id: null,
      editType: null,
      editEmail: null,
      editName: null,
      editPhoneNumber: null,
      editTitle: null,
      editMetro: null,
      editWorkType: [],
      editTechStatus: [],
      editApplicationStatus: null,
      editTechLevel: null,
      editStripeId: null,
      editAddress: null,
      editBio: null,
      editPassword: null,
      editSendEmail: null,
      editRate: null,
      editRateType: null,
      editIsActive: null,
      editVerified: null,
      editVaccination: null,
      sendEmailOptions: [
        { value: true, text: "yes" },
        { value: false, text: "no" },
      ],
      activeOptions: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" },
      ],
      rateTypeOptions: [
        { value: null, text: "null" },
        { value: "only full-time", text: "only full-time" },
        { value: "only part-time", text: "only part-time" },
      ],
      verifiedOptions: [
        { value: true, text: "true" },
        { value: false, text: "false" },
      ],
      // editVideo: null,
    };
  },
  watch: {
    propsData() {
      this.initData();
    },
  },
  created: function () {
    this.initOptions();
    this.initData();
  },
  methods: {
    initData: function () {
      this.id = this.propsData.id;
      this.editType = this.propsData.type
        ? this.propsData.type
        : constant.PANEL_TYPES.ADD;
      if (this.editType == constant.PANEL_TYPES.ADD) {
        this.panelTitle = "Add Consultant";
        this.buttonLabel = "Add Consultant";
      } else if (this.editType == constant.PANEL_TYPES.EDIT) {
        this.panelTitle = "Edit Consultant";
        this.buttonLabel = "Edit Consultant";
      }
      this.editEmail = this.propsData.email;
      this.editName = this.propsData.name;
      this.editMetro = {
        text: this.propsData.metro,
        value: this.propsData.metro,
      };
      this.editWorkType = (this.propsData.workType || "")
        .split(",")
        .filter((item) => item)
        .map((item) => ({
          text: item,
          value: item,
        }));
      this.editTechStatus = (this.propsData.status || "")
        .split(",")
        .filter((item) => item)
        .map((item) => ({
          text: item,
          value: item,
        }));
      this.editApplicationStatus = {
        text: this.propsData.applicationStatus,
        value: this.propsData.applicationStatus,
      };
      this.editPhoneNumber = this.propsData.phoneNumber
        ? this.propsData.phoneNumber
        : null;
      this.editTitle = this.propsData.title ? this.propsData.title : null;
      this.editAddress = this.propsData.address ? this.propsData.address : null;
      this.editStripeId = this.propsData.stripeId
        ? this.propsData.stripeId
        : null;
      this.editTechLevel = this.propsData.techLevel;
      this.editBio = this.propsData.bio;
      this.editPassword = null;
      this.editSendEmail = null;
      this.editIsActive = this.propsData.isActive;
      this.editRate = this.propsData.rate;
      this.editRateType = this.propsData.rateType
        ? this.propsData.rateType
        : null;
      this.editVerified = this.propsData.verified;
      this.editVaccination = this.propsData.vaccination;
    },
    initOptions: function () {
      this.initMetroOptions();
      this.initApplicationStautsOptions();
      this.initTechLevelOptions();
      this.initWorkTypeOptions();
      this.initTechStatusOptions();
    },
    initMetroOptions: function () {
      const metroArray = [];
      db.collection("metros")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((metro, index) => {
            metroArray.push({
              text: metro.name,
              value: metro.name,
            });
          });
          this.metroOptions = metroArray;
        });
    },
    initWorkTypeOptions: function () {
      const workTypeArray = [];
      db.collection("new_work_types")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((workType, index) => {
            workTypeArray.push({
              text: workType.name,
              value: workType.name,
            });
          });
          this.workTypeOptions = workTypeArray;
        });
    },
    initTechStatusOptions: function () {
      const techStatusArray = [];
      db.collection("tech_statuses")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((item, index) => {
            techStatusArray.push({
              text: item.name,
              value: item.name,
            });
          });
          this.techStatusOptions = techStatusArray;
        });
    },
    initApplicationStautsOptions: function () {
      const applicationStatusArray = [];
      constant.APPLICATION_STATUSES.forEach((item) => {
        applicationStatusArray.push({ text: item, value: item });
      });
      db.collection("application_statuses")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          documents.forEach((applicationStatus, index) => {
            applicationStatusArray.push({
              text: applicationStatus.name,
              value: applicationStatus.name,
            });
          });
          applicationStatusArray.push({ text: "null", value: null });
          this.applicationStatusOptions = applicationStatusArray;
        });
    },
    initTechLevelOptions: function () {
      const techLevelArray = [];
      db.collection("tech_levels")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((techLevel, index) => {
            techLevelArray.push({
              text: techLevel.name,
              value: techLevel.name,
            });
          });
          techLevelArray.push({ text: "null", value: null });
          this.techLevelOptions = techLevelArray;
          this.techLevelOptions.sort((a, b) => {
            if (a.order === null || a.order === undefined) return 1;
            if (b.order === null || b.order === undefined) return -1;
            return a.order - b.order;
          });
        });
    },
    buttonClick: function () {
      if (!this.editEmail) {
        this.$toasted.global.toast_error({ message: "email required" });
        return;
      }
      if (this.editPassword && this.editPassword.length < 8) {
        this.$toasted.global.toast_error({
          message: "please use at least 8 characters for the password",
        });
        return;
      }
      const data = {
        id: this.id,
        type: this.editType,
        email: this.editEmail,
        name: this.editName,
        metro: this.editMetro.value,
        workType: (this.editWorkType || []).map((item) => item.value).join(","),
        status: (this.editTechStatus || []).map((item) => item.value).join(","),
        applicationStatus: this.editApplicationStatus.value,
        techLevel: this.editTechLevel,
        bio: this.editBio,
        password: this.editPassword,
        sendEmail: this.editSendEmail,
        rate: utils.toNumber(this.editRate),
        rateType: this.editRateType,
        isActive: this.editIsActive ? true : false,
        phoneNumber: this.editPhoneNumber,
        title: this.editTitle,
        address: this.editAddress,
        stripeId: this.editStripeId,
        verified: this.editVerified,
        vaccination: this.editVaccination,
      };
      this.$emit("buttonClick", data);
    },
    onSelectWorkType(items, lastSelectItem) {
      this.editWorkType = items;
    },
    onSelectTechStatus(items, lastSelectItem) {
      this.editTechStatus = items;
    },
  },
};
</script>

